import { render } from "./LabApprove.vue?vue&type=template&id=bfa66e46"
import script from "./LabApprove.vue?vue&type=script&lang=js"
export * from "./LabApprove.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__